import React from 'react';
import { formatDate } from '../../../services/primitives/date-utils';
import { formatStatementAddress } from '../statement-details.data';
import * as S from '../statement-details.styles';

type AddressLike = {
    lines?: string[];
    city?: string;
    state?: string;
    postal?: string;
};

export type StatementPatientProviderCardsProps = {
    patient?: {
        first?: string;
        middle?: string;
        last?: string;
        suffix?: string;
        sex?: string;
        dob?: string;
        externalId?: string;
        phones?: string[];
        emails?: string[];
        addresses?: AddressLike[];
    };
    billingProvider?: {
        organization?: string;
        first?: string;
        middle?: string;
        last?: string;
        phone?: string;
        email?: string;
        addresses?: AddressLike[];
    };
};

export const StatementPatientProviderCards: React.FC<StatementPatientProviderCardsProps> = ({
    patient,
    billingProvider,
}) => {
    const providerName =
        billingProvider?.organization ||
        `${billingProvider?.first || ''} ${billingProvider?.middle || ''} ${billingProvider?.last || ''}`.trim() ||
        '—';

    return (
        <S.CardsRow>
            <S.HalfWidthCard>
                <S.SectionLabel>Patient</S.SectionLabel>
                <S.PatientName>
                    {patient?.first} {patient?.middle} {patient?.last} {patient?.suffix}
                    {patient?.sex && <S.SexBadge>{patient.sex}</S.SexBadge>}
                </S.PatientName>
                <S.CardContent>
                    <S.InfoLabel>DOB</S.InfoLabel>
                    <S.InfoValue>{patient?.dob ? formatDate(patient.dob, 'MMM dd, yyyy') : '—'}</S.InfoValue>
                    <S.InfoLabel>External ID</S.InfoLabel>
                    <S.InfoValue>{patient?.externalId || '—'}</S.InfoValue>
                    <S.InfoLabel>Phone</S.InfoLabel>
                    <S.InfoValue>{patient?.phones?.[0] || '—'}</S.InfoValue>
                    <S.InfoLabel>Email</S.InfoLabel>
                    {patient?.emails?.[0] ? (
                        <S.EmailLink href={`mailto:${patient.emails[0]}`}>{patient.emails[0]}</S.EmailLink>
                    ) : (
                        <S.InfoValueMuted>—</S.InfoValueMuted>
                    )}
                    <S.InfoLabel>Address</S.InfoLabel>
                    <S.InfoValue>{formatStatementAddress(patient?.addresses) || '—'}</S.InfoValue>
                </S.CardContent>
            </S.HalfWidthCard>

            <S.HalfWidthCard>
                <S.SectionLabel>Billing provider</S.SectionLabel>
                <S.ProviderName>{providerName}</S.ProviderName>
                <S.CardContent>
                    <S.InfoLabel>Phone</S.InfoLabel>
                    <S.InfoValue>{billingProvider?.phone || '—'}</S.InfoValue>
                    <S.InfoLabel>Email</S.InfoLabel>
                    {billingProvider?.email ? (
                        <S.EmailLink href={`mailto:${billingProvider.email}`}>{billingProvider.email}</S.EmailLink>
                    ) : (
                        <S.InfoValueMuted>—</S.InfoValueMuted>
                    )}
                    <S.InfoLabel>Address</S.InfoLabel>
                    <S.InfoValue>{formatStatementAddress(billingProvider?.addresses) || '—'}</S.InfoValue>
                </S.CardContent>
            </S.HalfWidthCard>
        </S.CardsRow>
    );
};
